import { makeAutoObservable } from "mobx";
import CatalogoGeneral from "../api/catalogoGeneral/catalogoGeneral";
import { getError } from "../util/util";

export class CatalogoGeneralStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
  loading = false;  

  
  getValoresCatalogo = async (catalogo) => {
    this.loading = true;
    try {
      const result = await CatalogoGeneral.getValoresCatalogo(catalogo)
      if(result.success) return Promise.resolve(result.data)
      else return Promise.resolve(null)
    } catch (error) {
      // Alertas
      this.displayError(error);
      return Promise.resolve(null)
    } finally {
      this.loading = false;
    }
  };
  
  displayError = (error) => {
    this.rootStore.alertStore.alertError(getError(error));
  } 

}
